import { Item, Wrapper } from './style';

const Tabs = ({ tabs, value, onClick = () => {} }) => {
  return (
    <Wrapper>
      {tabs.map((tab, idx) => (
        <Item
          key={idx}
          active={tab.value === value}
          onClick={() => onClick(tab)}
          count={tabs.length}
        >
          {tab.title}
        </Item>
      ))}
    </Wrapper>
  );
};

export default Tabs;
